import mutations from './mutations'
import getters from './getters'
import state from './state'
import actions from './actions'

export default {
  namespaced: true,
  mutations,
  getters,
  state,
  actions
}



// WEBPACK FOOTER //
// ./src/store/application/index.js